export const styles = {
    downloadPdfButton: {
        display: "inline-block",
        padding: "10px 20px",
        borderRadius: "5px",
        backgroundColor: "#007bff",
        color: "white",
        textDecoration: "none",
        fontSize: "16px",
        fontWeight: "bold",
        textAlign: "center",
        cursor: "pointer",
        flex: 1,
        maxWidth: "200px",
    },
    downloadExcelButton: {
        display: "inline-block",
        padding: "10px 20px",
        borderRadius: "5px",
        border: "none",
        backgroundColor: "#28a745",
        color: "white",
        fontSize: "16px",
        fontWeight: "bold",
        textAlign: "center",
        cursor: "pointer",
        flex: 1,
        maxWidth: "200px",
    },
    pdfPreviewCloseButton: {
        alignSelf: "flex-end",
        padding: "8px 15px",
        borderRadius: "5px",
        border: "none",
        backgroundColor: "#dc3545",
        color: "white",
        fontSize: "14px",
        cursor: "pointer",
        marginBottom: "15px",
    },
    pdfPreviewSubContainer: {
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "8px",
        width: "80%",
        height: "80%",
        display: "flex",
        flexDirection: "column",
    },
    pdfPreviewContainer: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1099,
    },
    applyFiltersButton: {
        padding: '10px 24px',
        backgroundColor: '#2563eb',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        color: 'white',
        transition: 'background-color 0.2s'
    },
    clearFiltersButton: {
        padding: '10px 20px',
        backgroundColor: 'white',
        border: '2px solid #e5e7eb',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        color: '#374151',
        transition: 'all 0.2s'
    },
    modalFooter: {
        padding: '20px 24px',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        gap: '12px',
        justifyContent: 'flex-end',
        position: 'sticky',
        bottom: 0,
        backgroundColor: 'white',
        borderRadius: '0 0 16px 16px'
    },
    activeFilters: {
        marginTop: '20px',
        padding: '16px',
        backgroundColor: '#eff6ff',
        borderRadius: '10px',
        border: '1px solid #bfdbfe'
    },
    activeFiltersP: {
        fontSize: '13px',
        color: '#1e40af',
        margin: 0,
        fontWeight: '500'
    },
    monthsButton: {
        padding: '12px',
        fontSize: '13px',
        fontWeight: '500',
        borderRadius: '10px',
        cursor: 'pointer',
        transition: 'all 0.2s'
    },
    monthsLabel: {
        display: 'block',
        fontSize: '14px',
        fontWeight: '600',
        color: '#374151',
        marginBottom: '12px'
    },
    yearsOptions: {
        width: '100%',
        padding: '12px',
        border: '2px solid #e5e7eb',
        borderRadius: '10px',
        fontSize: '14px',
        backgroundColor: 'white',
        cursor: 'pointer',
        transition: 'border-color 0.2s'
    },
    exerciceLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        fontWeight: '600',
        color: '#374151',
        marginBottom: '12px'
    },
    closeFiltersButton: {
        padding: '8px',
        backgroundColor: '#f3f4f6',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.2s'
    },
    openFiltersButton: {
        display: 'flex',
        alignItems: 'end',
        gap: '8px',
        padding: '6px 12px',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        transition: 'all 0.2s',
        position: 'relative'
    },
    selectedItemsSpan: {
        position: 'absolute',
        top: '-6px',
        right: '-6px',
        width: '20px',
        height: '20px',
        backgroundColor: '#ef4444',
        color: 'white',
        borderRadius: '50%',
        fontSize: '11px',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px solid white'
    },
    statsMainCard: {
        borderRadius: '12px',
        padding: '24px',
        border: '1px solid rgba(255,255,255,0.2)',
        boxShadow: '0 4px 6px rgba(0,0,0,0.07)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: 'hidden'
    },
    statsAbsolute: {
        position: 'absolute',
        top: '-50px',
        right: '-50px',
        width: '150px',
        height: '150px',
        backgroundColor: 'rgba(255,255,255,0.1)',
        borderRadius: '50%'
    },
    filtersOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9998,
        animation: 'fadeIn 0.2s ease'
    },
    filtersModal: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        zIndex: 9999,
        width: '90%',
        maxWidth: '600px',
        maxHeight: '90vh',
        overflow: 'auto',
        animation: 'slideIn 0.3s ease'
    },
    filtersHeaderModal: {
        padding: '24px',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        backgroundColor: 'white',
        borderRadius: '16px 16px 0 0',
        zIndex: 1
    }

}